export class Unresolved {

    key;

    constructor(key) {
        this.key = key;
    }

}
